import { createFileRoute } from "@tanstack/react-router";
import { CreditCard, Wallet } from "lucide-react";
import { Suspense } from "react";
import { depositPolicyQuery, stripeStatusQuery } from "@/api/billing";
import { warmQueries } from "@/api/warm";
import { useAuth } from "@/auth/AuthProvider";
import { SettingsCard } from "@/components/configuracoes/SettingsCard";
import { SinalSection } from "@/components/configuracoes/SinalSection";
import { StripeSection } from "@/components/configuracoes/StripeSection";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute("/_authed/configuracoes/pagamentos")({
  loader: ({ context: { queryClient, establishmentId } }) =>
    warmQueries(queryClient, [
      stripeStatusQuery(establishmentId),
      depositPolicyQuery(establishmentId),
    ]),
  staticData: {
    title: "Pagamentos",
    subtitle: "Conexão com a Stripe e valor do sinal antecipado.",
  },
  component: PagamentosPage,
});

/**
 * A Stripe é opcional e vem primeiro de propósito: sem ela o sinal não tem
 * como ser cobrado, então a ordem na tela é a ordem em que as duas coisas
 * precisam acontecer.
 */
function PagamentosPage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    // As duas seções usam `useSuspenseQuery`, e cada uma ganha a SUA
    // fronteira. Sem fronteira nenhuma a suspensão subiria até a raiz e
    // apagaria o painel inteiro; com uma só pros dois, o sinal — que é uma
    // consulta ao próprio banco — ficaria esperando o estado da conta
    // Stripe, que sai daqui, vai até a Stripe e volta.
    <div className="space-y-6">
      <SettingsCard icon={CreditCard} title="Stripe">
        <Suspense fallback={<Skeleton className="h-24 w-full" />}>
          <StripeSection establishmentId={user.establishment_id} />
        </Suspense>
      </SettingsCard>

      <SettingsCard
        icon={Wallet}
        title="Sinal antecipado"
        description="Entrada que o cliente paga pra confirmar o horário."
      >
        <Suspense fallback={<Skeleton className="h-32 w-full" />}>
          <SinalSection establishmentId={user.establishment_id} />
        </Suspense>
      </SettingsCard>
    </div>
  );
}
